import { listClients } from '@/modules/commercial/services/clientsService';
import { listCommercialOperations } from '@/modules/commercial/services/commercialOperationsService';
import type { CommercialOperation } from '@/modules/commercial/types';

export type CommercialDashboardStats = {
  activeOperations: number;
  pendingQuotations: number;
  activeRentals: number;
  recentSales: number;
  activeClients: number;
};

const ACTIVE_STATUSES = new Set<CommercialOperation['status']>([
  'pending',
  'approved',
  'in_progress',
]);

function isRecent(op: CommercialOperation, days: number): boolean {
  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - days);
  return op.updatedAt >= cutoff;
}

export async function fetchCommercialDashboardStats(): Promise<CommercialDashboardStats> {
  const [operations, clients] = await Promise.all([
    listCommercialOperations(),
    listClients(),
  ]);

  const active = operations.filter((o) => ACTIVE_STATUSES.has(o.status));

  return {
    activeOperations: active.length,
    pendingQuotations: operations.filter(
      (o) => o.type === 'quotation' && o.status === 'pending',
    ).length,
    activeRentals: operations.filter(
      (o) => o.type === 'rental' && ACTIVE_STATUSES.has(o.status),
    ).length,
    recentSales: operations.filter(
      (o) => o.type === 'sale' && isRecent(o, 30),
    ).length,
    activeClients: clients.filter((c) => c.active).length,
  };
}
